import { render, staticRenderFns } from "./SorryPageNotFound.vue?vue&type=template&id=f9e9bcf4&"
import script from "./SorryPageNotFound.vue?vue&type=script&lang=ts&"
export * from "./SorryPageNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports